import DevelopersSectionContent from "./developers-section/index";

export default function DevelopersSection() {
  return (
    <div className="px-8 font-inter">
      <DevelopersSectionContent />
    </div>
  );
}
